module.exports = __webpack_public_path__ + "static/media/yin-yang.b73ab786.gif";